import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChart8: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChart8"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM7 17H8.5V12H7V17ZM11.25 17H12.75V7H11.25V17ZM15.5 10V17H17V10H15.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChart8;
